import { React, useEffect, useState } from "react";
import styled from "styled-components";
import { useLanguage } from '../../../../Context/LanguageContext';
import { useTheme } from '../../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../../Styles/theme';

import { ReactComponent as LeftArrowSvg } from '../../../../image/LeftArrow.svg';
import moment from "moment";

export default function AttendanceRateBox(props) {
  const { lessonHistory } = props;
  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const [division, setDivision] = useState('month');
  const [rate, setRate] = useState(0);

  useEffect(() => {
    if (division === 'week') {
      let today = moment();
      let startDay = moment();

      for (let i = 0; i < 7; i++) {
        if (today.clone().subtract(i, 'day').format('dd') === 'Su') {
          startDay = today.clone().subtract(i, 'day');
          break;
        }
      }

      let historyCount = 0;

      for (let i = 0; i < lessonHistory.length; i++) {
        if (startDay.isBefore(moment(lessonHistory[i].classDate).subtract(1, 'milliseconds'))
          && startDay.clone().add(7, 'day').subtract(1, 'milliseconds').isAfter(moment(lessonHistory[i].classDate))
          && (lessonHistory[i].status === 1 || lessonHistory[i].status === 2)) {
          historyCount += 1;
        }
      }

      setRate(parseInt(Math.round((historyCount / 7) * 100)));
    }
    else {
      let year = moment().format('YYYY');
      let month = moment().format('MM');
      let date = new Date(year, month, 0).getDate();

      let startDay = moment(year + '-' + month + '-01T00:00:00').subtract(1, 'milliseconds');
      let endDay = startDay.clone().add(date, 'day').subtract(1, 'milliseconds');

      let historyCount = 0;

      for (let i = 0; i < lessonHistory.length; i++) {
        if (startDay.isBefore(moment(lessonHistory[i].classDate))
          && endDay.isAfter(moment(lessonHistory[i].classDate))
          && (lessonHistory[i].status === 1 || lessonHistory[i].status === 2)) {
          historyCount += 1;
        }
      }

      setRate(Math.round((historyCount / date) * 100));
    }

  }, [lessonHistory, division])


  return (
    <Box $isDark={isDark}>
      <TextWrapper>
        <Text fontFamily='NotoSansKR-Bold' fontSize={150} color={theme.subText} cursor='default'>{rate}</Text>
        <Text style={{ marginTop: '80px' }} fontFamily='NotoSansKR-Bold' fontSize={50} color={theme.subText} cursor='default'>%</Text>
      </TextWrapper>
      <TitleBox>
        <Button isClicked={division === 'week'} onClick={() => setDivision('week')}>
          {
            division === 'month' &&
            <StyledArrow />
          }
        </Button>
        <Text fontFamily='NotoSansKR-Bold' fontSize={15} color={theme.subText} cursor='default'>{division === 'month' ? t('memberDetail.monthlyAttendance') : t('memberDetail.weeklyAttendance')}</Text>
        <Button isClicked={division === 'week'} onClick={() => setDivision('month')}>
          {
            division === 'week' &&
            <StyledArrow isRight />
          }
        </Button>
      </TitleBox>
    </Box>
  )
}

const Box = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 301px;
  height: 268px;

  border-radius: 8px;
  background-color: ${props => props.theme.subBackground};
  box-shadow: ${props => props.$isDark ? 'none' : '0px 0px 10px 0px rgba(0, 0, 0, 0.05)'};
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 278px;
  height: 196px;
`;

const TitleBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  padding: 0px 12px 0px 12px;
  margin-top: 18px;

  height: 33px;

  border-radius: 8px;
  background-color: ${props => props.theme.buttonFill};
`;

const Button = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-top: 3px;

  width: 20px;
  height: 20px;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: ${props => props.isClicked ? `default` : `pointer`};
    }
  }
`;

const StyledArrow = styled(LeftArrowSvg)`
  width: 7px;
  height: auto;
  flex-shrink: 0;

  color: ${props => props.theme.subText};
  transform: ${props => props.isRight ? 'rotate(180deg)' : 'rotate(0deg)'};
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;
  padding: 0 0 0 0;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: ${props => props.cursor};
    }
  }
`;
